import { ErrorHandler, Injectable } from '@angular/core';
import { NeoLogService } from '@app/services/neo-log.service';
import { OtelService } from '@app/services/otel.service';

@Injectable()
export class NeoGlobalErrorHandler implements ErrorHandler {

  constructor(private neoLogService: NeoLogService, private otelService: OtelService) {}

  public handleError(error: unknown): void {
    this.neoLogService.error('NeoGlobalErrorHandler->handleError', error);
    console.error(error);

    // Guarded: a throw from otelService must never suppress error visibility -
    // tracing is a secondary observer of errors, not a gate on them.
    try {
      this.otelService.recordException(error);
    } catch (otelError) {
      this.neoLogService.error('NeoGlobalErrorHandler->handleError->otelService.recordException failed', otelError);
    }
  }
}
